/**
 * @file SessionStatusBadge.tsx
 * @brief Visual badge mapping `sessions.status` → variant.
 *
 * @details
 * Mirrors the colour conventions used by `CompanyStatusBadge` so the panel
 * speaks one visual language across every list/table. (`UserStatusBadge` was
 * the third of the set until 02-08-2026, when it was deleted as unused — user
 * status now shows only as the timeline spine colour, see
 * `features/users/components/userStatusStyles.ts`.)
 *
 * @author DES
 * @date 26-05-2026
 */

import { Badge } from "@/components/ui/Badge";
import type { SessionStatus } from "../schemas";

const LABEL: Record<SessionStatus, string> = {
  in_progress: "In progress",
  completed: "Completed",
  failed: "Failed",
  cancelled: "Cancelled",
  deleted: "Deleted",
};

export function SessionStatusBadge({ status }: { status: SessionStatus }) {
  switch (status) {
    case "completed":
      return <Badge variant="success">{LABEL.completed}</Badge>;
    case "in_progress":
      return <Badge variant="info">{LABEL.in_progress}</Badge>;
    case "failed":
      return <Badge variant="destructive">{LABEL.failed}</Badge>;
    case "cancelled":
      return <Badge variant="warning">{LABEL.cancelled}</Badge>;
    case "deleted":
      return <Badge variant="muted">{LABEL.deleted}</Badge>;
    default:
      return <Badge variant="muted">{String(status)}</Badge>;
  }
}
